export default defineNuxtPlugin((nuxtApp) => {
    /**
     * Recursively find all underlined nodes, including hyperlinks that contain them
     * @param {Array|Object} nodes
     * @returns {Array} filtered nodes
     */
    function getUnderlinedNodes(nodes) {
        let results = [];

        const processNode = (node) => {
            if (!node) return;

            // Keep hyperlink nodes if their content contains any underlined text
            if (node.nodeType === 'hyperlink' && node.content) {
                const underlinedChildren = node.content.filter(child =>
                    child.marks?.some(mark => mark.type === 'underline') &&
                    child.value?.trim() !== ''
                );

                if (underlinedChildren.length > 0) {
                    // Include the full hyperlink object
                    results.push(node);
                }
            }

            // Recurse through children if present
            if (node.content && Array.isArray(node.content)) {
                node.content.forEach(child => processNode(child));
            }
        };

        if (Array.isArray(nodes)) {
            nodes.forEach(node => processNode(node));
        } else if (typeof nodes === 'object') {
            processNode(nodes);
        }

        return results;
    }

    return {
        provide: {
            getUnderlinedNodes
        }
    };
});